export default __webpack_public_path__ + "static/media/github.cad5b2b0.svg";